// removed by extract-text-webpack-plugin
module.exports = {"absolute":"src-components-modules-Image-style----position-module---absolute---2b-SE position-absolute","initial":"src-components-modules-Image-style----position-module---initial---3KsoF position-initial","relative":"src-components-modules-Image-style----position-module---relative---2KuOb position-relative"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Image/style/position.module.css
// module id = 1478
// module chunks = 168707334958949